import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { RequirementField } from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.interface';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { conformToMask } from 'angular2-text-mask';
import { tap, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'ba-ssn',
    templateUrl: 'ssn-attribute.component.html'
})
export class SsnAttributeComponent implements OnInit, OnDestroy {

    @Input() field: RequirementField;
    @Input() form: UntypedFormGroup;
    @Input() disabled: boolean;

    maskedValue: Function;
    mask = [/\d|\*/, /\d|\*/, /\d|\*/, '-', /\d|\*/, /\d|\*/, '-', /\d/, /\d/, /\d/, /\d/];

    destroyed$ = new Subject<void>();

    @ViewChild('ssnInput') inputEl: Element;

    ngOnInit() {

        // Strip out any characters added by the mask directive before setting the control
        // value.
        this.control.valueChanges.pipe(
            takeUntil(this.destroyed$),
            tap((value: string = '') => {
                if (typeof value !== 'string') {
                    return;
                }
                const unmaskedValue = value.replace(/-/g, '');
                this.control.setValue(unmaskedValue, { emitEvent: false, emitModelToViewChange: false });
            })
        ).subscribe();

        this.control.setValidators([Validators.minLength(9), (control) => {
            if (!this.control.pristine) {
                return Validators.pattern(/^\d+$/)(control);
            }
            return () => () => null;
        }]);

        if (this.field.value) {
            this.maskedValue = conformToMask(this.field.value, this.mask, {guide: false});
        }
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }

    onFocus(event) {

        // Select the entire contents of the input on focus
        event.target.select();
    }

    onBlur() {

        // If the value is empty on blur, restore the field's original value and mark
        // the control as pristine.
        if (!this.control.value || this.control.value.length === 0) {
            this.control.markAsPristine();
            this.control.setValue(this.field.value);
            this.control.setErrors(null);
        }
    }

    onKeyDown($event: KeyboardEvent) {

        // Clear the value at the very beginning of editing. SSNs shouldn't be modified
        // as much as re-entered.
        if (
            $event.shiftKey
            || $event.metaKey
            || $event.ctrlKey
            || ['\t', '\n'].includes($event.key || '')
        ) {
            return;
        }
        if (this.control.pristine) {
            this.control.setValue('');
        }
    }

    get control() {
        return this.form.controls[this.field.alias];
    }
}
